<template>
  <div class="navbar-outer">
    <div class="container navbar-inner">
      <div v-if="school_code == utils.sdcm_code || school_code == utils.whrj_code" :class="currentPath == `/${school_code}/` ? 'nav-item active' : 'nav-item'">
        <router-link :to="`/${school_code}`">平台首页</router-link>
      </div>
      <div v-else :class="currentPath == `/${school_code}/zy` ? 'nav-item active' : 'nav-item'">
        <router-link :to="`/${school_code}/zy`">首页</router-link>
      </div>

      <template v-for="(item, index) in school_code == utils.sdcm_code ? sdcmRouteArr : routeArr">
        <div :class="currentPath.indexOf(item.path) != -1 ? 'nav-item active' : 'nav-item'" :key="index">
          <template v-if="item.type == 'path'">
            <div class="link-nav" @click="clickRouter(item)">
              {{ item.name }}
              <div class="xxzy-list" v-if="item.path.indexOf('/xxzyk') > -1">
                <div class="xxzy-box">
                  <div v-for="elem in xxzyRouterList" :key="elem.path" @click.stop="xxzykClickRoute(elem)" :class="$route.path.indexOf(elem.path) != -1 ? 'xxzy-item active' : 'xxzy-item'">
                    {{ elem.name }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="item.type == 'click'">
            <a href="javascript:void(0)" @click="clickFunc(item)">{{ item.name }}</a>
          </template>
          <template v-else>
            <a :href="item.path" target="_blank">{{ item.name }}</a>
          </template>
        </div>
      </template>

      <template v-if="school_code == yzSchoolCode">
        <a class="nav-item" href="https://zhsz.jiaoyu.cn/100047/10/index.html" target="_blank">教学研究中心</a>
      </template>
    </div>
    <component :is="dialogConfig.name"></component>
  </div>
</template>

<script>
import services from "../assets/js/services";
import utils from "../assets/js/utils";
import appleRes from "../components/appleRes.vue";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "Navbar",
  components: { appleRes },
  props: {
    target: {
      type: String,
      default: "_self",
    }
  },
  data () {
    return {
      school_code: localStorage.getItem("schoolCode"),
      isMobile: utils.isMobile(),
      utils,
      services,
      currentPath: "",
      routeArr: [
        // { name: "思政元素体系", path: "/zy/szysk", type: "path" },
        {
          name: "思政元素图谱",
          type: "path",
          path: "/zy/elementGraph",
        },
        { name: "课程思政元素库", path: "/zy/szzyk", type: "path" },
        // { name: "使用帮助", type: "click", path: "/zy/syzn" }
      ],
      sdcmRouteArr: [
        // { name: "思政元素体系", path: "/zy/szysk", type: "path" },
        {
          name: "思政元素图谱",
          type: "path",
          path: "/zy/elementGraph",
          // sort: 0.1
        },
        { name: "热点资源", path: "/zy/szzyk", type: "path" },
        // { name: "使用帮助", type: "click", path: "/zy/syzn" }
      ],
      dialogConfig: { name: "" },
      yzSchoolCode: utils.yz_code
    };
  },
  computed: {
    ...mapState({
      schoolMenu: state => state.appsLogin.schoolMenu,
      xxzyRouterList: state => state.class.xxzyRouterList
    })
  },
  async mounted () {
    this.currentPath = this.$route.path;
    await this.getSchoolMenuData();
    this.initializeMenu();
    this.getOpenClass();

    // 思政元素图谱隐藏 "使用帮助"
    if (this.$route.path.indexOf("/zy/elementGraph") == -1) {
      const sybzRoute = { name: "使用帮助", type: "click", path: "/zy/syzn" }
      this.routeArr.push(sybzRoute)
      this.sdcmRouteArr.push(sybzRoute)
    }
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin", "getSchoolMenuStatus"]),
    ...mapMutations(["setxxzyRouterList"]),

    xxzykClickRoute (item) {
      if (this.school_code == utils.sdcm_code && item.path.indexOf("rwsy") > -1) {
        this.goAppsDetailsBeforeLogin().then(() => {
          const routeUrl = this.$router.resolve({ path: `/${this.school_code}/zy/xxzyk/${item.path}` });
          window.open(routeUrl.href, this.target)
        });
      } else {
        const routeUrl = this.$router.resolve({ path: `/${this.school_code}/zy/xxzyk/${item.path}` });
        window.open(routeUrl.href, this.target)
      }
    },

    async getSchoolMenuData () {
      if (!this.schoolMenu) {
        await this.getSchoolMenuStatus(this.school_code);
      }
    },

    initializeMenu () {
      const menuType = this.school_code == utils.sdcm_code || this.school_code == utils.whrj_code
        ? "sdcmRouteArr"
        : "routeArr";

      this.addMenuItems(menuType);
      this.sortMenuItems(menuType);
    },

    addMenuItems (menuType) {
      if (this.schoolMenu?.open_xxzyk) {
        this[menuType].push({
          name: menuType === "sdcmRouteArr" ? "培训资源" : "教师研修库",
          path: "/zy/xxzyk",
          type: "path"
        });
      }

      if (this.schoolMenu?.open_ability == 1) {
        this[menuType].push({
          name: "专业能力图谱",
          path: "/zy/majorGraph",
          type: "path"
        });
      }

      if (this.schoolMenu?.open_szztk) {
        this[menuType].push({
          name: menuType === "sdcmRouteArr" ? "专题资源" : "思政专题库",
          path: "/zy/szztk",
          type: "path"
        });
      }

      if (this.schoolMenu?.open_cases) {
        this[menuType].push({
          name: "案例资源库",
          path: "/zy/alzyk",
          type: "path"
        });
      }

      if (this.schoolMenu?.special) {
        this[menuType].push({
          name: this.schoolMenu.special.name,
          path: "/zy/region",
          type: "path"
        });
      }

      if (this.schoolMenu?.course) {
        this[menuType].push({
          name: this.schoolMenu.course.name,
          type: "path",
          path: "/zy/szsfkc"
        });
      }

      if (this.schoolMenu?.open_qyzyk) {
        this[menuType].push({
          type: "path",
          name: "区域文化库",
          path: "/zy/region/list"
        });
      }

      if (this.schoolMenu && !this.schoolMenu.close_bkzyk) {
        this[menuType].push({
          name: "在线协同备课",
          type: "click"
        });
      }

      if (this.school_code == utils.ynjd_code) {
        this[menuType].push({
          name: "党建育人库",
          type: "click"
        });
      }

      // this[menuType].push({
      //   name: "思政元素图谱",
      //   type: "path",
      //   path: "/zy/elementGraph",
      //   sort: 0.1
      // });
    },

    sortMenuItems (menuType) {
      const sortValues = {
        "党建育人库": 0,
        "/szysk": 1,
        "/zy/majorGraph": 2,
        "/zy/elementGraph": 3,
        "/szzyk": 4,
        "/alzyk": 5,
        "/szztk": 6,
        "/szsfkc": 7,
        "/zy/region": 8,
        "region/list": 9,
        "/xxzyk": 10,
        "在线协同备课": 11,
        "/syzn": 12,
      };

      this[menuType].forEach(item => {
        if (item.path) {
          for (const [key, value] of Object.entries(sortValues)) {
            if (item.path.includes(key)) {
              item.sort = value;
              break;
            }
          }
        } else {
          if (item.name === "在线协同备课") item.sort = 11;
          if (item.name === "党建育人库") item.sort = 0;
        }
      });

      this[menuType].sort((a, b) => (a.sort || 0) - (b.sort || 0));
    },

    clickFunc (item) {
      if (item.name == "党建育人库") {
        window.open(`https://zhsz.jiaoyu.cn/100048/12/index.html`, this.target);
        return;
      }

      this.goAppsDetailsBeforeLogin().then(() => {
        if (item.name == "在线协同备课") {
          window.open(`${services.BEIKE_SERVER}/${this.school_code}/lesson/resource`, this.target);
        } else if (item.name == "使用帮助") {
          const routeUrl = this.$router.push(`/${this.school_code}/zy/syzn`);
          window.open(routeUrl.href, this.target)
        }
      });
    },

    clickRouter (item) {

      if (item.path.includes("/zy/region") && !item.path.includes("/zy/region/list")) {
        const routeUrl = this.$router.resolve({ path: `/${this.school_code}/zy/region` });
        window.open(routeUrl.href, this.target);
      } else {
        const routeUrl = this.$router.resolve({ path: `/${this.school_code}${item.path}` });
        window.open(routeUrl.href, this.target);
      }
    },

    beikeMessageModal () {
      this.dialogConfig.name = "appleRes";
    },

    async getOpenClass () {
      const res = await this.services.getOpenClass({
        school_code: this.school_code,
        course_category_id: "60,2,6,55,86,87,362"
      });
      if (res.code == "0000") {
        this.setxxzyRouterList([
          ...res.data.material_category_id,
          ...res.data.course_category_id
        ]);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.navbar-outer {
    width: 100%;
    height: 42px;
    background: linear-gradient(162deg, #dd363a 0%, #df4531 100%);

    .navbar-inner {
        display: flex;
        justify-content: space-between;

        .nav-item {
            color: #ffffff;
            position: relative;
            line-height: 42px;
            font-size: 16px;
            text-align: center;
            opacity: 0.8;

            a,
            .link-nav {
                color: #ffffff;
                display: inline-block;
                text-decoration: none;
                cursor: pointer;

                .xxzy-list {
                    z-index: 99;
                    position: absolute;
                    display: none;
                    top: 43px;
                    left: 50%;
                    transform: translate(-50%, 10px);
                    background: #fff;
                    width: 630px;
                    border-bottom: 1px solid #ea6a59;
                    height: 95px;
                    background-size: 100%;

                    .xxzy-box {
                        margin: 14px 40px 0;
                        display: flex;
                        flex-wrap: wrap;

                        .xxzy-item {
                            width: 23%;
                            margin-top: 6px;
                            height: 24px;
                            font-size: 13px;
                            line-height: 24px;
                            font-weight: 400;
                            color: #383838;
                            background: #f8f9f9;
                            margin-left: 11px;

                            &:hover,
                            &.active {
                                background: #fff8f3;
                                color: #dd3639;
                            }
                        }
                    }

                    &::before {
                        content: '';
                        display: block;
                        position: absolute;
                        top: -14px;
                        left: 50%;
                        transform: translateX(-50%);
                        border-top: 7px solid transparent;
                        border-left: 7px solid transparent;
                        border-bottom: 7px solid #fff;
                        border-right: 7px solid transparent;
                    }

                    &::after {
                        content: '';
                        display: block;
                        top: -12px;
                        width: 100%;
                        height: 14px;
                        position: absolute;
                        background: transparent;
                    }
                }
            }

            &.active,
            &:hover {
                opacity: 1;
                font-weight: bold;
            }

            &:hover .link-nav .xxzy-list {
                display: block;
            }

            &.active:after,
            &:hover:after {
                content: '';
                width: 24px;
                height: 3px;
                background: #ffffff;
                border-radius: 2px;
                display: block;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translate(-50%, 0);
            }
        }

        .nav-category {
            text-align: center;
            width: 245px;
            font-size: 16px;
            font-weight: bold;
            color: #da3033;
            background-color: #ffffff;
            opacity: 1;
            line-height: 42px;
            transition: all 0.3s;
        }
    }
}

.jioayu-chrome {
    font-size: 14px;
    color: #333;
    display: inline;
    line-height: 30px;

    a,
    a:hover {
        color: #df4531;
    }

    a:hover {
        text-decoration: underline;
    }
}
</style>